import { getToken, WithCSSVar } from "@chakra-ui/react";
// eslint-disable-next-line no-restricted-imports
import { Dict } from "@chakra-ui/utils";
import { EnumReactionColor } from "src/types/common-enum";

export const getBarColorHex = (color: EnumReactionColor, theme: WithCSSVar<Dict>) => {
    const getColorFromTheme = getToken("colors", ["blue.600", "yellow.600", "red.600", "green.600", "gray.400"]);

    switch (color) {
        case EnumReactionColor.Blue:
            return getColorFromTheme(theme)[0];
        case EnumReactionColor.Yellow:
            return getColorFromTheme(theme)[1];
        case EnumReactionColor.Red:
            return getColorFromTheme(theme)[2];
        case EnumReactionColor.Green:
            return getColorFromTheme(theme)[3];
        case EnumReactionColor.Grey:
            return getColorFromTheme(theme)[4];
        default:
            return (({}: { color: never }) => getColorFromTheme(theme)[4])({ color });
    }
};
